
import { defineComponent , reactive } from 'vue';
import { useStore } from 'vuex'
export default defineComponent({
    name: 'TopBar',
    props: {
        msg: String,
        viewIndex:{
            type:Number,
            default:0
        }
    },
    emits:['changeView'],
    setup(){
        const store = useStore()
        const signInfo = reactive(store.state.signInfo)
        console.log(signInfo)
        return {
            signInfo
        }
    }
});
